import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const inputCls = "h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-sm text-navy placeholder:text-slate-400 transition-[border-color,box-shadow] focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/30";
export const darkInputCls = "h-12 w-full rounded-xl border border-white/10 bg-white/5 px-4 text-sm text-white placeholder:text-slate-500 transition-[border-color,box-shadow] focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/30";

export function Field({ label, id, dark, children }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className={`text-xs font-semibold uppercase tracking-wider ${dark ? "text-slate-400" : "text-slate-500"}`}>{label}</Label>
      {children}
    </div>
  );
}

export function SelectField({ label, id, value, onChange, options, placeholder, testid, dark }) {
  return (
    <Field label={label} id={id} dark={dark}>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id} data-testid={testid} className={`${dark ? darkInputCls : inputCls} justify-between`}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o, i) => (
            <SelectItem key={o} value={o} data-testid={`${testid}-option-${i}`}>{o}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}
